export const roundNumberToFixed = (num: number, toFixed = 2): number => {
  return Number((Math.round(num * 100) / 100).toFixed(toFixed));
};

export const roundFloatToFixed = (num: number, toFixed = 5): number => {
  return Number(num.toFixed(toFixed));
};

export const calcPercent = (value: number, total: number, toFixed?: number) => {
  return roundNumberToFixed((value / total) * 100, toFixed);
};

export const calcMinMaxPercent = (value: number, max: number, min: number) => {
  const val = Math.round(((value - min) / (max - min)) * 100);
  if (val >= 100) return 100;
  if (val <= 0) return 0;
  return val;
};

export const calcPercentChange = (valueA: number, valueB: number, toFixed?: number) => {
  return roundNumberToFixed(((valueA - valueB) / valueA) * 100, toFixed);
};
